module.exports = __webpack_public_path__ + "static/media/Mapa de México con chinchetas Lenguas en Peligro.257784d1.png";